import HTTP from './AxiosConfig';

const getPartners = () =>
    HTTP.get('/partner/warehouse-form').finally(
        (response) =>
            new Promise((resolve) => {
                resolve(response);
            }),
    );

const validateEmail = (email) =>
    HTTP.get(`/user/validate-email?email=${email}`).finally(
        (response) =>
            new Promise((resolve) => {
                resolve(response);
            }),
    );

const loginEndpoint = (loginData) => HTTP.post('/login', loginData);

const recoverPassword = (email) => HTTP.get(`/recover-password?email=${email}`);

const changePassword = (passwords) => HTTP.post('/user/change-password', passwords);

export {
    loginEndpoint,
    recoverPassword,
    getPartners,
    validateEmail,
    changePassword,
};
